import RenderManager from '../rendering/render-manager';
import getRelativeCoordinates from "../utils/get-relative-coordinates";
import SlideManager from '../utils/slide-manager';
import getWheelDelta from "../utils/wheel-delta";
import QuizManager from '../quizes/quiz-manager';

const ButtonAction = {
    0: 'rotate',
    2: 'translate'
};

const TouchAction = {
    1: 'rotate',
    2: 'translate'
};

const isScrollable2DObject = (e) => {
    const isTable = (el) => {
        let p = el;
        let t = false;

        while (p.parentElement) {
            if (p.parentElement.classList.contains('has-table')) {
                t = true;
            }
            p = p.parentElement;
        }

        return t;
    }

    let conditions = [
        (el) => QuizManager._dom.mobileHintsCnt && QuizManager._dom.mobileHintsCnt[0].contains(el),
        (el) => QuizManager._dom.quizWrap && QuizManager._dom.quizWrap[0].contains(el),
        (el) => isTable(el)
    ];

    for (let f of conditions) {
        if (f(e.target)) {
            return true;
        }
    }

    return false;
}

class ObjectRotationControlsDom {
    constructor(controls, domElement) {
        this._controls = controls;
        this._domElement = domElement;

        this._enabled = false;

        this._mouseButton = null;

        this._onContextMenuThis = this._onContextMenu.bind(this);
        this._onMouseDownThis = this._onMouseDown.bind(this);
        this._onMouseUpThis = this._onMouseUp.bind(this);
        this._onMouseMoveThis = this._onMouseMove.bind(this);
        this._onMouseWheelThis = this._onMouseWheel.bind(this);

        this._apply = false;
    }

    get enabled() { return this._enabled; }

    set enabled(enabled) {
        enabled = Boolean(enabled);

        if (enabled === this._enabled) return;
        this._enabled = enabled;

        if (enabled) {
            this._domElement.addEventListener('contextmenu', this._onContextMenuThis, false);
            this._domElement.addEventListener('mousedown', this._onMouseDownThis, false);
            this._domElement.addEventListener('touchstart', this._onMouseDownThis, false);

            window.addEventListener('mouseup', this._onMouseUpThis, false);
            window.addEventListener('touchend', this._onMouseUpThis, false);

            window.addEventListener('mousemove', this._onMouseMoveThis, false);
            window.addEventListener('touchmove', this._onMouseMoveThis, { passive: false });

            this._domElement.addEventListener('wheel', this._onMouseWheelThis, false);
        } else {
            this._domElement.removeEventListener('contextmenu', this._onContextMenuThis);

            this._domElement.removeEventListener('mousedown', this._onMouseDownThis);
            this._domElement.removeEventListener('touchstart', this._onMouseDownThis);

            window.removeEventListener('mouseup', this._onMouseUpThis);
            window.removeEventListener('touchend', this._onMouseUpThis);

            window.removeEventListener('mousemove', this._onMouseMoveThis);
            window.removeEventListener('touchmove', this._onMouseMoveThis);

            this._domElement.removeEventListener('wheel', this._onMouseWheelThis);

            this._mouseButton = null;
        }
    }

    get apply() { return this._apply; }

    _onContextMenu(e) { e.preventDefault(); }

    _onMouseDown(event) {
        event.preventDefault();

        if (this._mouseButton !== null) return;
        this._mouseButton = event.button;

        const action = ButtonAction[event.button] || TouchAction[event.touches.length];
        if (!action) return;

        const coords = getRelativeCoordinates(event);
        const mousePos = RenderManager.toScreenSpaceCoords(coords);

        this._apply = event.altKey;
        this._controls.startDragging(action, mousePos);
    }

    _onMouseUp(event) {
        if (!event.touches && !Q3.editMode) event.preventDefault();

        if (event.button !== this._mouseButton) return;
        this._mouseButton = null;

        this._apply = event.altKey;
        this._controls.stopDragging();
    }

    _onMouseMove(event) {
        if (event.touches && !isScrollable2DObject(event)) event.preventDefault();

        const coords = getRelativeCoordinates(event);
        const newMousePos = RenderManager.toScreenSpaceCoords(coords);

        this._apply = event.altKey;
        this._controls.drag(newMousePos);
    }

    _onMouseWheel(event) {
        if (SlideManager.currentSlide.slideQuiz && SlideManager.currentSlide.slideQuiz.type === "plopQuiz")
            return;

        const coords = getRelativeCoordinates(event);
        const mousePos = RenderManager.toScreenSpaceCoords(coords);
        const delta = -getWheelDelta(event, 'deltaY');

        this._apply = event.altKey;
        this._controls.zoom(mousePos, delta);
    }

    clearApply() {
        this._apply = false;
    }
}

export default ObjectRotationControlsDom;
